import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';

import EventPopup from 'shared/components/popup/EventPopup';

import { setCookie } from 'shared/utils/cookie';
import { initModal, pushModal } from 'shared/actions/modal.action';
import { pushToastApp } from 'shared/actions/toast.action';

import boomImg from 'shared/assets/temp/boom.gif';

@connect((state, props) => ({}), { initModal, pushModal, pushToastApp })
class EventPopupContainer extends Component {
  handleClose = () => {
    return this.props.initModal;
  };
  handleSubmit = () => {
    this.props.initModal();

    setTimeout(() => {
      console.log('asdasda');
      setCookie('nsda_cupon', 'true', 1);
      this.props.pushToastApp({ message: '적용되었습니다.' });
    }, 1200);
  };
  componentDidMount() {
    setTimeout(() => {
      this.handleSubmit();
    }, 2500);
  }
  render() {
    const img = `https://image.okaydoctor.co.kr/image/m-popup-img-complete@2x.png`;
    return (
      <Dim
        style={{
          backgroundImage: `url(${boomImg})`,
          backgroundSize: '100% 100%',
        }}
      >
        <EventPopup img={img} pcImg={img} />
      </Dim>
    );
  }
}

export default EventPopupContainer;
